import { resourceQueryKeys } from './resourceQueryKeys.js';
import { userPinnedResourcesQueryKeys } from '../../resource-pin/queries/userPinnedResourcesQueryKeys.js';

const resourceQueryPredicates = {
  resourceDetail: (query, resourceId) => {
    const resourceDetailKey = resourceQueryKeys.resourceDetail(resourceId);
    return query.queryKey[0] === resourceDetailKey[0] && query.queryKey[1] === resourceDetailKey[1];
  },
  resourceMultiple: (query, resourceIds) => {
    for (const resourceId of resourceIds) {
      if (resourceQueryPredicates.resourceDetail(query, resourceId)) return true;
    }
    return false;
  },
  resourceList: (query) => {
    return Boolean(query.queryKey[0] === resourceQueryKeys.resourceList()[0]);
  },
  resourceContextSearchList: (query) => {
    return Boolean(query.queryKey[0] === resourceQueryKeys.resourceContextSearchList()[0]);
  },
  /**
  * matches any resource list (v2/resources/filter) or context search list (v2/search)
  */
  resourceListAny: (query) => {
    if (query.meta?.ignoreResourceUpdate) return false;
    return [
      resourceQueryKeys.resourceContextSearchList()[0],
      resourceQueryKeys.resourceList()[0],
      userPinnedResourcesQueryKeys.userPins()[0]
    ].includes(query.queryKey[0]);
  },
  resourceListByParentId: (query, parentId) => {
    if (query.queryKey[0] === resourceQueryKeys.resourceList()[0]) {
      const queryKey = query.queryKey;
      if (queryKey[1]?.parentId === parentId && !!parentId) {
        return true;
      }
      if (!queryKey[1]?.parentId) {
        return true;
      }
    }
    return false;
  },
  resourceContextSearchListByParentId: (query, parentId) => {
    if (query.queryKey[0] === resourceQueryKeys.resourceContextSearchList()[0]) {
      const queryKey = query.queryKey;
      if (queryKey[1]?.filters?.parentId === parentId && !!parentId) return true;
    }
    return false;
  },
  resourceListAnyByParentId: (query, parentId) => {
    return resourceQueryPredicates.resourceListByParentId(query, parentId) || resourceQueryPredicates.resourceContextSearchListByParentId(query, parentId);
  },
  resourceListAnyByMultipleParentIds: (query, parentIds) => {
    return parentIds.some((parentId) => resourceQueryPredicates.resourceListAnyByParentId(query, parentId));
  },
  summaryAll: (query) => {
    return query.queryKey[0] === resourceQueryKeys.totals()[0];
  },
  summaryByParent: (query, parentId) => {
    if (query.queryKey[0] !== resourceQueryKeys.totals()[0]) return false;
    if (!parentId) return true;
    return query.queryKey[1] === parentId;
  },
  summaryByParents: (query, parentIds) => {
    if (query.queryKey[0] !== resourceQueryKeys.totals()[0]) return false;
    return parentIds.includes(query.queryKey[1]);
  }
};

export { resourceQueryPredicates };
//# sourceMappingURL=resourceQueryPredicates.js.map
